import { ReactNode } from 'react';
import { useSidebar } from '@/context/SidebarContext';
import { useTranslation } from 'react-i18next';
import { TopNavbar } from './TopNavbar';

interface SidebarLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

export const SidebarLayout = ({ sidebar, children }: SidebarLayoutProps) => {
  const { isCollapsed, pathContext } = useSidebar();
  const { t } = useTranslation();

  return (
    <div className="h-screen bg-background">
      {sidebar}
      <div
        className={`flex h-screen flex-col transition-all duration-300 ${
          isCollapsed ? 'ml-[60px]' : 'ml-[240px]'
        }`}
      >
        <TopNavbar />
        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto">
          <div className="flex min-w-0 flex-1 flex-col">{children}</div>
          <footer className="py-2 px-4 flex items-center justify-center gap-3 text-[10px] text-muted-foreground shrink-0">
            <a href="/terms" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors lowercase">
              {t('legalPage.termsTitle')}
            </a>
            <span>|</span>
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors lowercase">
              {t('legalPage.privacyTitle')}
            </a>
          </footer>
        </main>
      </div>
    </div>
  );
};
